
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popup/flash-sales",
      function () {
        return require("private-next-pages/popup/flash-sales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popup/flash-sales"])
      });
    }
  